class ThreeSixty extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.connected();
  }

  async connected() {
    await this.init();
    await this.render();
    await this.addEventListeners();
    await this.ready();
  }

  async init() {
    this.video = this.querySelector('video');
    this.isDragging = false;
    this.initialTimestamp = 0;
    this.isLoading = false;
  }

  async render() {
    // Add your rendering logic here if needed
  }

  async addEventListeners() {
    this.addEventListener('pointerdown', this.handleStart.bind(this));
    window.addEventListener('pointerup', this.handleEnd.bind(this));
    window.addEventListener('touchend', this.handleEnd.bind(this));
    
    // Add event listeners for video loading
    this.video.addEventListener('loadeddata', this.handleVideoLoaded.bind(this));
    this.video.addEventListener('play', this.handleVideoPlay.bind(this));
    this.video.addEventListener('pause', this.handleVideoPause.bind(this));
  }

  async ready() {
    // Add any additional initialization logic here
    this.classList.add('loading');
  }

  // Update the video's current time based on the custom timestamp position
  updateVideoTime(event) {
    const boundingRect = this.getBoundingClientRect();
    const offsetX = event.clientX - boundingRect.left;
    const percentageChange = (offsetX - this.initialMouseX) / boundingRect.width;
  
    // Calculate the new timestamp with looping support
    let newTimestamp = this.initialTimestamp - percentageChange * this.video.duration;
    if (newTimestamp < 0) {
      newTimestamp = this.video.duration + (newTimestamp % this.video.duration); // Loop to the end
    } else if (newTimestamp > this.video.duration) {
      newTimestamp = newTimestamp % this.video.duration; // Loop to the start
    }
  
    this.video.currentTime = newTimestamp;
  }  

  // Event listeners for mouse and touch interactions
  handleStart(event) {
    event.preventDefault();
    this.isDragging = true;
    this.classList.add('dragging');
    this.video.pause();
    const boundingRect = this.getBoundingClientRect();
    this.initialMouseX = event.clientX - boundingRect.left;
    this.initialTimestamp = this.video.currentTime;
    window.addEventListener('pointermove', this.handleMove.bind(this));
    document.addEventListener('touchmove', this.eventPreventDefault.bind(this), { passive: false });
  }

  eventPreventDefault(event) {
    event.preventDefault();
  }

  handleMove(event) {
    if (this.isDragging) {
      event.preventDefault();
      this.updateVideoTime(event);
    } else {
      this.handleEnd();
    }
  }

  handleEnd() {
    this.isDragging = false;
    this.classList.remove('dragging');
    window.removeEventListener('pointermove', this.handleMove.bind(this));
    document.removeEventListener('touchmove', this.eventPreventDefault.bind(this), { passive: false });
  }

  // Event listener for video loaded
  handleVideoLoaded() {
    this.isLoading = false;
    this.classList.remove('loading');
    // Add any UI changes or animations to indicate that the video has loaded
  }

  // Event listener for video play
  handleVideoPlay() {
    this.isLoading = false;
    this.classList.remove('loading');
    // Add any UI changes or animations to indicate that the video is playing
  }

  // Event listener for video pause
  handleVideoPause() {
    // Add any UI changes or animations to indicate that the video has paused
  }
}

customElements.define('three-sixty', ThreeSixty);
